// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IChatsGetUnreadChatsDesktopRequest,
  TChatsGetUnreadChatsDesktopModel,
  IMappers,
  TChatsGetUnreadChatsDesktopResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IChatListResponseSchema } from '../../../entities/chat/ChatListResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createChatsGetUnreadChatsDesktopModel(
  parameters: IChatsGetUnreadChatsDesktopRequest,
): TChatsGetUnreadChatsDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'chats',
    pathApi: '/v1/chats/get-unread-chats-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IChatsGetUnreadChatsDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IChatsGetUnreadChatsDesktopRequest;
}

export async function fetchChatsGetUnreadChatsDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsGetUnreadChatsDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsGetUnreadChatsDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsGetUnreadChatsDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsGetUnreadChatsDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatListResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsGetUnreadChatsDesktopResponse>;
}
